(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /**
   * « Afficher plus de décors ». Les pages ajoutées et la position dans la
   * grille sont retenues pour la session (sessionStorage, par adresse de
   * collection et filtres) : au retour depuis une fiche ou au rechargement,
   * les mêmes décors reviennent et la page reprend où on l'avait laissée,
   * au lieu de retomber sur les 40 premiers et de glisser jusqu'au pied.
   * Une visite neuve (lien, menu) repart du début.
   */
  class MsLoadMore extends HTMLElement {
    #busy = false;
    static #restored = false;

    connectedCallback() {
      this.btn = this.querySelector('[data-ms-more-btn]');
      this.label = this.querySelector('[data-ms-more-label]');
      this.count = this.querySelector('[data-ms-more-count]');
      this.bar = this.querySelector('[data-ms-more-bar]');
      this.pages = this.querySelector('[data-ms-more-pages]');
      // Avec le script : le bouton et le compteur, pas les pages.
      if (this.pages) this.pages.hidden = true;
      if (this.count) this.count.hidden = false;
      if (this.bar) this.bar.hidden = false;
      if (this.btn) {
        this.btn.hidden = !this.dataset.next;
        this.btn.addEventListener('click', this.#onClick);
      }
      window.addEventListener('pagehide', this.#save);
      this.#grid?.addEventListener('click', this.#onGridClick, true);
      // C'est ce bloc qui replace la page, après avoir rechargé les décors :
      // le navigateur, lui, la ferait tomber sur le pied.
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      this.#restore();
    }

    disconnectedCallback() {
      this.btn?.removeEventListener('click', this.#onClick);
      window.removeEventListener('pagehide', this.#save);
      this.#grid?.removeEventListener('click', this.#onGridClick, true);
    }

    /** Une adresse par collection et par filtres, sans le numéro de page. */
    get #key() {
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      return 'ms-more:' + url.pathname + url.search;
    }

    #read() {
      try { return JSON.parse(sessionStorage.getItem(this.#key) || 'null'); } catch { return null; }
    }

    #write(state) {
      try { sessionStorage.setItem(this.#key, JSON.stringify(state)); } catch { /* stockage indisponible */ }
    }

    get #grid() {
      return this.closest('[data-ref="main-collection-products"]')?.querySelector('[data-ref="main-collection-grid"]');
    }

    /**
     * Le repère : le décor cliqué, sinon le premier visible, et sa hauteur à
     * l'écran. C'est lui qu'on remet en place : une position en pixels se
     * fausse dès que les images se chargent dans un autre ordre.
     */
    #clickedAt = 0;

    #save = (event) => {
      // Le départ qui suit un clic sur un décor garde ce décor pour repère.
      if (event?.type === 'pagehide' && Date.now() - this.#clickedAt < 5000) return;
      if (event?.type === 'click') this.#clickedAt = Date.now();
      const state = this.#read() || { loads: 0 };
      let card = event?.type === 'click' ? event.target.closest?.('a[href*="/products/"]') : null;
      if (!card) {
        card = [...(this.#grid?.querySelectorAll('a[href*="/products/"]') || [])].find((a) => a.getBoundingClientRect().bottom > 80);
      }
      state.y = Math.round(window.scrollY);
      if (card) {
        state.anchor = new URL(card.href, window.location.href).pathname;
        state.top = Math.round(card.getBoundingClientRect().top);
      }
      this.#write(state);
    };

    #onGridClick = (event) => {
      if (event.target.closest?.('a[href*="/products/"]')) this.#save(event);
    };

    /** Remet le repère à sa hauteur, plusieurs fois pendant que les images arrivent. */
    #toAnchor(state) {
      const find = () => [...(this.#grid?.querySelectorAll('a[href*="/products/"]') || [])]
        .find((a) => new URL(a.href, window.location.href).pathname === state.anchor);
      const place = () => {
        const card = find();
        if (card) window.scrollTo({ top: window.scrollY + card.getBoundingClientRect().top - (state.top || 0), behavior: 'instant' });
        else if (typeof state.y === 'number') window.scrollTo({ top: state.y, behavior: 'instant' });
      };
      place();
      for (const delay of [150, 400, 900, 1600]) setTimeout(place, delay);
    }

    /** Au retour ou au rechargement : les mêmes décors, puis la même position. */
    async #restore() {
      if (MsLoadMore.#restored) return;
      MsLoadMore.#restored = true;
      const nav = performance.getEntriesByType?.('navigation')?.[0]?.type;
      const state = this.#read();
      const onFirstPage = !new URL(window.location.href).searchParams.get('page');
      if (nav !== 'back_forward' && nav !== 'reload') {
        try { sessionStorage.removeItem(this.#key); } catch { /* idem */ }
        return;
      }
      if (!state || !onFirstPage) return;
      for (let i = 0; i < (state.loads || 0) && this.dataset.next; i += 1) {
        const ok = await this.#fetchNext(false);
        if (!ok) break;
      }
      requestAnimationFrame(() => this.#toAnchor(state));
    }

    #onClick = async () => {
      if (await this.#fetchNext(true)) {
        const state = this.#read() || { loads: 0 };
        state.loads = (state.loads || 0) + 1;
        this.#write(state);
      }
    };

    /** @returns {Promise<boolean>} vrai si une page de décors a été ajoutée */
    async #fetchNext(animate) {
      if (this.#busy || !this.dataset.next) return false;
      this.#busy = true;
      this.btn?.setAttribute('aria-busy', 'true');
      if (this.label) this.label.textContent = 'Chargement…';
      let ok = false;
      try {
        const response = await fetch(this.dataset.next, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = this.closest('[data-ref="main-collection-products"]')?.querySelector('[data-ref="main-collection-grid"]');
        const incoming = html.querySelector('[data-ref="main-collection-grid"]');
        if (!grid || !incoming) throw new Error('grille introuvable');
        const fragment = document.createDocumentFragment();
        for (const node of [...incoming.children]) {
          if (animate) node.classList.add('ms-more-in');
          fragment.appendChild(node);
        }
        grid.appendChild(fragment);
        const next = html.querySelector('[data-ref="load-more"]');
        this.dataset.next = next?.dataset.next || '';
        const seen = Number(next?.dataset.seen || this.dataset.total);
        this.dataset.seen = String(seen);
        this.#paint(seen);
        ok = true;
      } catch (error) {
        console.error('Afficher plus :', error);
        if (this.label) this.label.textContent = 'Réessayer';
      } finally {
        this.#busy = false;
        this.btn?.removeAttribute('aria-busy');
        if (!this.dataset.next && this.btn) this.btn.hidden = true;
        else if (this.label && this.label.textContent === 'Chargement…') this.label.textContent = 'Afficher plus de décors';
      }
      return ok;
    }

    #paint(seen) {
      const total = Number(this.dataset.total) || seen;
      const el = this.querySelector('[data-ms-more-seen]');
      if (el) el.textContent = String(seen);
      if (this.bar) this.bar.style.setProperty('--ms-more-pct', Math.round((seen / total) * 100) + '%');
    }
  }
  if (!customElements.get('ms-load-more')) customElements.define('ms-load-more', MsLoadMore);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-404"] && !Shopify.designMode) return;
  try {
    
  class Ms404 {
    constructor(root) {
      this.root = root;
      this.strip = (root.dataset.strip || '').toLowerCase();
      this.input = root.querySelector('[data-ms-404-q]');
      this.list = root.querySelector('[data-ms-404-suggest]');
      this.near = root.querySelector('[data-ms-404-near]');
      this.nearList = root.querySelector('[data-ms-404-near-list]');
      this.ctrl = null;
      this.timer = null;
      this.#track();
      this.#bindSearch();
      this.#nearFromPath();
    }

    /** Même règle que le snippet ms-clean-title : le nom est après la barre (ancien format : avant). */
    clean(title) {
      let t = String(title || '').trim();
      if (t.includes('|')) {
        const parts = t.split('|');
        t = (parts[0].includes(',') ? parts[parts.length - 1] : parts[0]).trim();
      }
      for (const prefix of [this.strip, 'papier peint panoramique', 'panneau décoratif']) {
        if (prefix && t.toLowerCase().startsWith(prefix)) { t = t.slice(prefix.length).trim(); break; }
      }
      return t || String(title || '');
    }

    async suggest(q, limit, signal) {
      const url = new URL((window.Shopify?.routes?.root || '/') + 'search/suggest.json', location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', String(limit));
      url.searchParams.set('resources[options][fields]', 'title,product_type,tag,body');
      const r = await fetch(url, { signal });
      if (!r.ok) return [];
      const d = await r.json();
      return d?.resources?.results?.products || [];
    }

    #el(tag, cls, text) {
      const e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text) e.textContent = text;
      return e;
    }

    #img(src, width) {
      if (!src) return null;
      const u = new URL(src, location.origin);
      u.searchParams.set('width', String(width));
      const img = document.createElement('img');
      img.src = u.toString();
      img.alt = '';
      img.loading = 'lazy';
      return img;
    }

    /* ── La recherche, avec suggestions sous le champ ── */
    #bindSearch() {
      if (!this.input || !this.list) return;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        const q = this.input.value.trim();
        if (q.length < 2) { this.list.hidden = true; return; }
        this.timer = setTimeout(() => this.#renderSuggest(q), 180);
      });
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.list.hidden = true;
        if (e.key === 'ArrowDown') { this.list.querySelector('a')?.focus(); e.preventDefault(); }
      });
      this.list.addEventListener('keydown', (e) => {
        const links = [...this.list.querySelectorAll('a')];
        const i = links.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && i < links.length - 1) { links[i + 1].focus(); e.preventDefault(); }
        if (e.key === 'ArrowUp') { (i > 0 ? links[i - 1] : this.input).focus(); e.preventDefault(); }
        if (e.key === 'Escape') { this.list.hidden = true; this.input.focus(); }
      });
      document.addEventListener('click', (e) => { if (!this.root.contains(e.target)) this.list.hidden = true; });
    }

    async #renderSuggest(q) {
      this.ctrl?.abort();
      this.ctrl = new AbortController();
      try {
        const products = await this.suggest(q, 6, this.ctrl.signal);
        this.list.replaceChildren();
        for (const p of products) {
          const li = this.#el('li');
          li.setAttribute('role', 'option');
          const a = this.#el('a');
          a.href = p.url;
          const img = this.#img(p.image || p.featured_image?.url, 80);
          if (img) a.append(img);
          a.append(this.#el('span', '', this.clean(p.title)));
          li.append(a);
          this.list.append(li);
        }
        this.list.hidden = products.length === 0;
      } catch (err) {
        if (err.name !== 'AbortError') this.list.hidden = true;
      }
    }

    /* ── Une ancienne fiche produit : les décors les plus proches ── */
    async #nearFromPath() {
      const m = location.pathname.match(/\/products\/([^/?#]+)/);
      if (!m || !this.near) return;
      const stop = new Set(['papier', 'peint', 'panoramique', 'de', 'du', 'des', 'la', 'le', 'les', 'et', 'pour', 'sur', 'mesure', 'd', 'l', 'au', 'aux', 'a', 'en']);
      const words = decodeURIComponent(m[1]).toLowerCase().split(/[-_]+/).filter((w) => w.length > 2 && !stop.has(w) && !/^\d+$/.test(w));
      if (this.input && words.length) this.input.value = words.slice(0, 3).join(' ');
      // Du plus précis au plus large : tous les mots, puis chaque mot seul.
      const queries = [words.join(' '), ...words];
      const seen = new Map();
      for (const q of queries) {
        if (!q || seen.size >= 4) continue;
        try {
          for (const p of await this.suggest(q, 4)) {
            const key = new URL(p.url, location.origin).pathname;
            if (!seen.has(key) && seen.size < 4) seen.set(key, p);
          }
        } catch { /* la grille reste là */ }
      }
      if (seen.size === 0) return;
      for (const p of seen.values()) {
        const li = this.#el('li');
        const a = this.#el('a', 'ms404__near-card');
        a.href = p.url;
        const img = this.#img(p.image || p.featured_image?.url, 600);
        if (img) a.append(img);
        a.append(this.#el('span', '', this.clean(p.title)));
        li.append(a);
        this.nearList.append(li);
      }
      this.near.hidden = false;
    }

    /* ── La mesure : seulement avec le consentement statistiques ── */
    #track() {
      const send = () => {
        const payload = { page_path_requested: location.pathname + location.search, page_referrer: document.referrer || '(direct)' };
        if (typeof window.gtag === 'function') window.gtag('event', 'page_404', payload);
      };
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
        if (privacy.analyticsProcessingAllowed()) { send(); return; }
        // Consentement donné plus tard, sur cette page : on envoie à ce moment-là.
        document.addEventListener('visitorConsentCollected', (e) => {
          if (e.detail?.analyticsAllowed) send();
        }, { once: true });
        return;
      }
      // Sans API de confidentialité Shopify, le mode consentement Google
      // (réglé par Consentik dans layout/theme.liquid) décide de ce qui part.
      send();
    }
  }

  for (const root of document.querySelectorAll('[data-ms-404]')) new Ms404(root);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-article"] && !Shopify.designMode) return;
  try {
    
  /**
   * Sommaire de l'article, construit depuis les titres de niveau 2 réellement
   * présents. Écrire les ancres à la main dans chaque article reviendrait à les
   * maintenir à chaque relecture — et à les oublier.
   */
  function msArticleToc() {
    const body = document.querySelector('[data-ms-article-body]');
    const box = document.querySelector('[data-ms-toc]');
    const list = document.querySelector('[data-ms-toc-list]');
    if (!body || !box || !list || box.dataset.msReady) return;
    box.dataset.msReady = '1';

    const headings = [...body.querySelectorAll('h2')];
    // Un sommaire de deux lignes n'aide personne : il occupe une colonne pour rien.
    if (headings.length < 3) return;

    const slug = (text, i) => {
      const base = text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      return base ? `${base}-${i}` : `section-${i}`;
    };

    const links = [];
    for (const [i, h] of headings.entries()) {
      if (!h.id) h.id = slug(h.textContent, i + 1);
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent;
      li.append(a);
      list.append(li);
      links.push(a);
    }
    box.hidden = false;

    // Surlignage du titre courant. rootMargin décale la zone de détection sous
    // l'en-tête collant, sinon le titre actif change trop tôt.
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        for (const a of links) a.classList.toggle('is-current', a.hash === `#${entry.target.id}`);
      }
    }, { rootMargin: '-110px 0px -70% 0px' });

    for (const h of headings) observer.observe(h);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', msArticleToc);
  else msArticleToc();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-avant-apres"] && !Shopify.designMode) return;
  try {
    
  /**
   * Avant / après. Le range natif porte la valeur ; ce script se contente de la
   * recopier dans une variable CSS. Sans lui, le curseur reste au centre mais la
   * page ne casse pas.
   */
  function msAaBind(stage) {
    if (stage.dataset.msReady) return;
    stage.dataset.msReady = '1';

    const range = stage.querySelector('.ms-aa__range');
    if (!range) return;

    const paint = () => stage.style.setProperty('--ms-aa-pos', range.value);
    range.addEventListener('input', paint);
    paint();
  }

  function msAaBoot() {
    for (const stage of document.querySelectorAll('.ms-aa__stage')) msAaBind(stage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', msAaBoot);
  } else {
    msAaBoot();
  }
  document.addEventListener('shopify:section:load', msAaBoot);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-avis-page"] && !Shopify.designMode) return;
  try {
    
  class MsAvisPage extends HTMLElement {
    #frame = 0;

    connectedCallback() {
      this.track = this.querySelector('[data-msap-track]');
      if (!this.track) return;
      this.items = [...this.track.querySelectorAll('.msap__item')];
      this.prev = this.querySelector('[data-msap-prev]');
      this.next = this.querySelector('[data-msap-next]');
      this.fill = this.querySelector('[data-msap-progress]');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.prev?.addEventListener('click', () => this.#go(-1));
      this.next?.addEventListener('click', () => this.#go(1));
      this.track.addEventListener('scroll', () => this.#schedule(), { passive: true });
      window.addEventListener('resize', () => this.#schedule(), { passive: true });
      this.#bindDrag();
      this.#startOnSecond();
      this.#update();
      requestAnimationFrame(() => this.classList.add('is-ready'));
    }

    /* On ouvre sur le 2e avis : un voisin de chaque côté, la piste paraît pleine. */
    #startOnSecond() {
      const second = this.items[1];
      if (!second || this.items.length < 3) return;
      this.track.scrollLeft = second.offsetLeft + second.offsetWidth / 2 - this.track.clientWidth / 2;
    }

    #schedule() {
      if (this.#frame) return;
      this.#frame = requestAnimationFrame(() => {
        this.#frame = 0;
        this.#update();
      });
    }

    /** Distance de chaque carte au centre de la piste, carte courante, flèches et progression. */
    #update() {
      const box = this.track.getBoundingClientRect();
      const center = box.left + box.width / 2;
      let current = 0;
      let best = Infinity;
      for (const [index, item] of this.items.entries()) {
        const r = item.getBoundingClientRect();
        const d = Math.abs(r.left + r.width / 2 - center) / (r.width || 1);
        item.style.setProperty('--msap-d', d.toFixed(3));
        if (d < best) { best = d; current = index; }
      }
      for (const [index, item] of this.items.entries()) item.classList.toggle('is-current', index === current);
      this.current = current;
      const last = this.items.length - 1;
      if (this.prev) this.prev.disabled = current <= 0;
      if (this.next) this.next.disabled = current >= last;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const ratio = max > 0 ? this.track.scrollLeft / max : 1;
      this.fill?.style.setProperty('--msap-progress', Math.min(1, Math.max(0.04, ratio)).toFixed(3));
    }

    #go(dir) {
      const target = this.items[Math.min(this.items.length - 1, Math.max(0, (this.current || 0) + dir))];
      if (!target) return;
      const offset = target.offsetLeft + target.offsetWidth / 2 - this.track.clientWidth / 2;
      this.track.scrollTo({ left: offset, behavior: this.reduce.matches ? 'auto' : 'smooth' });
    }

    /* La souris fait glisser comme le doigt ; au lâcher, la carte la plus proche se centre. */
    #bindDrag() {
      let down = false;
      let startX = 0;
      let startLeft = 0;
      let moved = false;
      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true;
        moved = false;
        startX = e.clientX;
        startLeft = this.track.scrollLeft;
        this.track.setPointerCapture(e.pointerId);
      });
      this.track.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 4) { moved = true; this.track.classList.add('is-dragging'); }
        this.track.scrollLeft = startLeft - dx;
      });
      const up = () => {
        if (!down) return;
        down = false;
        this.track.classList.remove('is-dragging');
        if (moved) this.#go(0);
      };
      this.track.addEventListener('pointerup', up);
      this.track.addEventListener('pointercancel', up);
      this.track.addEventListener('lostpointercapture', up);
    }
  }
  if (!customElements.get('ms-avis-page')) customElements.define('ms-avis-page', MsAvisPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-avis-slider"] && !Shopify.designMode) return;
  try {
    
  class MsAvisSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-msavis-track]');
      this.prev = this.querySelector('[data-msavis-prev]');
      this.next = this.querySelector('[data-msavis-next]');
      if (!this.track) return;
      this.prev?.addEventListener('click', () => this.#go(-1));
      this.next?.addEventListener('click', () => this.#go(1));
      this.track.addEventListener('scroll', () => this.#sync(), { passive: true });
      this.#bindDrag();
      this.#sync();
    }

    #step() {
      const item = this.track.querySelector('.msavis__item');
      return item ? item.getBoundingClientRect().width + 16 : this.track.clientWidth * 0.8;
    }

    #go(dir) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: dir * this.#step(), behavior: reduce ? 'auto' : 'smooth' });
    }

    #sync() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    }

    /* La souris fait glisser comme le doigt. Un clic net reste un clic. */
    #bindDrag() {
      let down = false, startX = 0, startLeft = 0, moved = false;
      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false;
        startX = e.clientX; startLeft = this.track.scrollLeft;
        this.track.setPointerCapture(e.pointerId);
      });
      this.track.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 4) { moved = true; this.track.classList.add('is-dragging'); }
        this.track.scrollLeft = startLeft - dx;
      });
      const up = () => {
        if (!down) return;
        down = false;
        this.track.classList.remove('is-dragging');
        if (moved) {
          const step = this.#step();
          const target = Math.round(this.track.scrollLeft / step) * step;
          this.track.scrollTo({ left: target, behavior: 'smooth' });
        }
      };
      this.track.addEventListener('pointerup', up);
      this.track.addEventListener('pointercancel', up);
      this.track.addEventListener('lostpointercapture', up);
    }
  }
  if (!customElements.get('ms-avis-slider')) customElements.define('ms-avis-slider', MsAvisSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-conciergerie"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KEY_TIME = 'mscg-seconds';
    const KEY_SHOWN = 'mscg-shown';

    const boot = (root) => {
      if (root.dataset.mscgBound) return;
      root.dataset.mscgBound = '1';

      const dialog = document.getElementById(root.dataset.dialog);
      if (!dialog || typeof dialog.showModal !== 'function') return;

      const markShown = () => {
        try { localStorage.setItem(KEY_SHOWN, String(Date.now())); } catch { /* stockage indisponible */ }
      };

      /**
       * @param {boolean} auto vrai quand la fenêtre s'ouvre d'elle-même :
       * seule cette ouverture-là compte pour « déjà montrée ». Cliquer sur le
       * lanceur ne doit pas priver la personne de l'invitation.
       */
      const panels = dialog.querySelectorAll('[data-mscg-panel]');
      const showPanel = (name) => {
        for (const p of panels) p.hidden = p.dataset.mscgPanel !== name;
      };

      const open = (auto) => {
        if (dialog.open) return;
        // D'elle-même, la fenêtre demande d'abord ce qui retient ; depuis le
        // lanceur, elle va droit au formulaire.
        const hasAsk = Boolean(dialog.querySelector('[data-mscg-panel="ask"]'));
        showPanel(auto === true && hasAsk ? 'ask' : 'form');
        dialog.showModal();
        if (window.msScrollLock) window.msScrollLock(true);
        if (auto === true) markShown();
        // Pas de focus automatique sur écran tactile : il ouvrirait le clavier
        // et ferait zoomer la page avant même qu'on ait lu la question.
        if (navigator.maxTouchPoints > 0) return;
        if (auto === true && hasAsk) dialog.querySelector('[data-mscg-tile]')?.focus({ preventScroll: true });
        else dialog.querySelector('[data-mscg-body]')?.focus({ preventScroll: true });
      };

      // Une tuile : la réponse se pose dessous, puis on propose d'écrire.
      const answerBox = dialog.querySelector('[data-mscg-answer]');
      const answerText = dialog.querySelector('[data-mscg-answer-text]');
      for (const tile of dialog.querySelectorAll('[data-mscg-tile]')) {
        tile.addEventListener('click', () => {
          for (const t of dialog.querySelectorAll('[data-mscg-tile]')) t.classList.toggle('is-on', t === tile);
          const topic = dialog.querySelector(`[data-mscg-topic][value="${CSS.escape(tile.dataset.mscgTile)}"]`);
          if (topic) { topic.checked = true; topic.dispatchEvent(new Event('change', { bubbles: true })); }
          if (!tile.dataset.answer) { showPanel('form'); dialog.querySelector('[data-mscg-body]')?.focus({ preventScroll: true }); return; }
          if (answerText) answerText.textContent = tile.dataset.answer;
          if (answerBox) { answerBox.hidden = true; void answerBox.offsetWidth; answerBox.hidden = false; }
        });
      }
      dialog.querySelector('[data-mscg-to-form]')?.addEventListener('click', () => {
        showPanel('form');
        dialog.querySelector('[data-mscg-body]')?.focus({ preventScroll: true });
      });
      // ── La feuille sous le clavier (écrans tactiles) ──
      const vv = window.visualViewport;
      if (vv && navigator.maxTouchPoints > 0) {
        let raf = 0;
        const fit = () => {
          if (!dialog.open) { dialog.classList.remove('mscg--kb'); return; }
          const keyboard = window.innerHeight - vv.height > 120;
          dialog.classList.toggle('mscg--kb', keyboard);
          if (!keyboard) {
            dialog.style.removeProperty('--mscg-vv-h');
            dialog.style.removeProperty('--mscg-vv-top');
            return;
          }
          dialog.style.setProperty('--mscg-vv-h', `${Math.round(vv.height)}px`);
          dialog.style.setProperty('--mscg-vv-top', `${Math.round(vv.offsetTop)}px`);
          const el = document.activeElement;
          if (el && dialog.contains(el) && /^(INPUT|TEXTAREA)$/.test(el.tagName)) {
            el.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        };
        const queue = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(fit); };
        vv.addEventListener('resize', queue);
        vv.addEventListener('scroll', queue);
        dialog.addEventListener('focusin', () => window.setTimeout(fit, 380));
      }

      // ── L'Échantillon ── sur une fiche, le bouton mène droit au bloc de l'échantillon de CE décor.
      const gift = dialog.querySelector('[data-mscg-gift]');
      if (gift) {
        const go = gift.querySelector('[data-mscg-gift-go]');
        const essai = document.querySelector('[data-ms-essai]');
        if (go && essai) {
          const goLabel = go.querySelector('[data-mscg-gift-go-label]');
          if (goLabel && root.dataset.giftProductCta) goLabel.textContent = root.dataset.giftProductCta;
          go.addEventListener('click', (e) => {
            e.preventDefault();
            if (dialog.open) dialog.close();
            window.setTimeout(() => essai.scrollIntoView({ block: 'center', behavior: 'smooth' }), 80);
          });
        }
      }

      const close = () => { if (dialog.open) dialog.close(); };
      // Échap et le fond passent par l'événement natif : le verrou se lève là.
      dialog.addEventListener('close', () => { if (window.msScrollLock) window.msScrollLock(false); });

      root.querySelector('[data-mscg-open]')?.addEventListener('click', () => open(false));
      for (const btn of dialog.querySelectorAll('[data-mscg-close]')) btn.addEventListener('click', close);
      dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });

      // Le sujet choisi change l'exemple du champ message : la cliente sait
      // quoi écrire, et la réponse peut être préparée avant de la lire.
      const body = dialog.querySelector('[data-mscg-body]');
      for (const topic of dialog.querySelectorAll('[data-mscg-topic]')) {
        topic.addEventListener('change', () => {
          if (body && topic.dataset.hint) body.placeholder = topic.dataset.hint;
        });
        if (topic.checked && body && topic.dataset.hint) body.placeholder = topic.dataset.hint;
      }

      // Après un envoi, la page revient avec le remerciement : on l'ouvre.
      if (root.querySelector('[data-mscg-posted]')) {
        open(false);
        return;
      }
      // #conciergerie dans l'adresse : ouverture immédiate (liens, tests),
      // au chargement comme au clic sur un lien de la page.
      window.addEventListener('hashchange', () => {
        if (window.location.hash === '#conciergerie') open(false);
      });
      if (window.location.hash === '#conciergerie') {
        open(false);
        return;
      }

      // ── L'invitation, après deux minutes cumulées sur le site ──
      if (root.dataset.auto !== '1') return;
      const delay = parseInt(root.dataset.delay, 10) || 120;
      const days = parseInt(root.dataset.days, 10) || 7;

      let shownAt = 0;
      try { shownAt = parseInt(localStorage.getItem(KEY_SHOWN) || '0', 10); } catch { /* ignoré */ }
      if (shownAt && Date.now() - shownAt < days * 86400000) return;

      let seconds = 0;
      try { seconds = parseInt(sessionStorage.getItem(KEY_TIME) || '0', 10); } catch { /* ignoré */ }

      const busy = () => {
        const active = document.activeElement;
        const typing = active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
        const other = document.querySelector('dialog[open]:not([data-mscg-dialog]), .msq__modal:not([hidden])');
        // Un autre pop-up vient de se fermer (Le Grand Tirage) : l'invitation attend son tour, sans s'enchaîner.
        let calme = 0;
        try { calme = parseInt(sessionStorage.getItem('ms-popup-calme') || '0', 10); } catch { /* ignoré */ }
        return typing || Boolean(other) || document.hidden || Date.now() < calme;
      };

      const tick = window.setInterval(() => {
        if (document.hidden) return;
        seconds += 5;
        try { sessionStorage.setItem(KEY_TIME, String(seconds)); } catch { /* ignoré */ }
        if (seconds < delay) return;
        if (busy()) return;
        window.clearInterval(tick);
        open(true);
      }, 5000);
    };

    const start = () => {
      for (const el of document.querySelectorAll('[data-mscg]')) boot(el);
    };
    start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-etanche"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ms-etanche')) {
    class MsEtanche extends HTMLElement {
      #controller = null;
      #decors = [];
      #decor = null;
      #dims = null;
      #pending = false;

      connectedCallback() {
        this.#controller = new AbortController();
        const signal = this.#controller.signal;
        try { this.#decors = JSON.parse(this.querySelector('script[data-msetan-decors]')?.textContent || '[]'); } catch { this.#decors = []; }
        this.w = this.querySelector('[data-msetan-w]');
        this.h = this.querySelector('[data-msetan-h]');
        this.margin = this.querySelector('[data-msetan-margin]');
        this.atc = this.querySelector('[data-msetan-atc]');
        this.picker = this.querySelector('[data-msetan-picker]');
        for (const input of [this.w, this.h, this.margin]) input?.addEventListener('input', () => this.#calc(), { signal });
        this.margin?.addEventListener('change', () => this.#calc(), { signal });
        this.atc?.addEventListener('click', () => this.#add(), { signal });
        this.emptyLabel = this.querySelector('[data-msetan-atc-label]')?.textContent.trim() || 'Calculer mon prix';
        // Deux boutons « Changer » (sur l'image, et à l'étape 1) : le focus revient sur celui qui a ouvert.
        for (const b of this.querySelectorAll('[data-msetan-open-picker]')) b.addEventListener('click', () => { this.opener = b; this.#openPicker(); }, { signal });
        this.querySelector('[data-msetan-close]')?.addEventListener('click', () => this.picker.close(), { signal });
        this.picker?.addEventListener('click', (e) => { if (e.target === this.picker) this.picker.close(); }, { signal });
        this.querySelector('[data-msetan-search]')?.addEventListener('input', (e) => this.#renderList(e.target.value), { signal });
        this.querySelector('[data-msetan-sample]')?.addEventListener('click', (e) => this.#addSample(e.currentTarget), { signal });
        this.querySelector('.msetan__thumbs')?.addEventListener('click', (e) => this.#thumb(e), { signal });

        const wanted = new URL(window.location.href).searchParams.get('decor') || this.dataset.defaultDecor;
        this.#select(this.#decors.find((d) => d.h === wanted) || this.#decors[0] || null);
        this.#calc();
      }

      disconnectedCallback() {
        this.#controller?.abort();
      }

      #money(cents) {
        const euros = cents / 100;
        const text = Number.isInteger(euros) ? String(euros) : euros.toFixed(2).replace('.', ',');
        return `${text.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} €`;
      }

      /* ── Le décor ── */
      #select(decor) {
        this.#decor = decor;
        const name = this.querySelector('[data-msetan-decor-name]');
        const col = this.querySelector('[data-msetan-decor-col]');
        const cap = this.querySelector('[data-msetan-caption]');
        const thumb = this.querySelector('[data-msetan-thumb="decor"]');
        if (!decor) return;
        name.textContent = decor.t;
        for (const img of this.querySelectorAll('[data-msetan-decor-img]')) { img.src = decor.s; img.alt = ''; }
        if (col) { col.textContent = decor.c ? `Collection ${decor.c}` : ''; col.hidden = !decor.c; }
        this.querySelector('[data-msetan-caption-name]').textContent = decor.t;
        if (thumb) {
          thumb.hidden = false;
          thumb.querySelector('[data-msetan-thumb-img]').src = decor.s;
        }
        this.#showMain(decor.i, true);
        cap.hidden = false;
      }

      #showMain(src, isDecor) {
        const main = this.querySelector('[data-msetan-main]');
        if (main && src) main.src = src;
        this.querySelector('[data-msetan-caption]').hidden = !isDecor;
        for (const t of this.querySelectorAll('[data-msetan-thumb]')) {
          t.classList.toggle('is-active', isDecor ? t.dataset.msetanThumb === 'decor' : t.dataset.msetanThumb === src);
        }
      }

      #thumb(e) {
        const t = e.target.closest('[data-msetan-thumb]');
        if (!t) return;
        if (t.dataset.msetanThumb === 'decor') this.#showMain(this.#decor?.i, true);
        else this.#showMain(t.dataset.msetanThumb, false);
      }

      #openPicker() {
        this.#renderList(this.querySelector('[data-msetan-search]')?.value || '');
        this.picker.showModal();
        this.querySelector('[data-msetan-search]')?.focus();
      }

      #renderList(query) {
        const list = this.querySelector('[data-msetan-list]');
        const q = query.trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
        const items = this.#decors.filter((d) => !q || d.t.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(q));
        list.replaceChildren(...items.map((d) => {
          const li = document.createElement('li');
          li.className = 'msetan__item';
          const b = document.createElement('button');
          b.type = 'button';
          if (this.#decor?.h === d.h) b.setAttribute('aria-current', 'true');
          const img = document.createElement('img');
          img.src = d.s; img.alt = ''; img.loading = 'lazy'; img.width = 160; img.height = 200;
          const span = document.createElement('span');
          span.textContent = d.t;
          b.append(img, span);
          b.addEventListener('click', () => {
            this.#select(d);
            this.picker.close();
            (this.opener || this.querySelector('[data-msetan-open-picker]'))?.focus();
          });
          li.append(b);
          return li;
        }));
        this.querySelector('[data-msetan-empty]').hidden = items.length > 0;
      }

      /* ── Les cotes, la surface, le prix ── */
      #calc() {
        const w = Math.round(Number(this.w?.value));
        const h = Math.round(Number(this.h?.value));
        const recap = this.querySelector('[data-msetan-recap]');
        const label = this.querySelector('[data-msetan-atc-label]');
        const total = this.querySelector('[data-msetan-total]');
        const minNote = this.querySelector('[data-msetan-min]');
        if (!(w > 0 && h > 0)) {
          this.#dims = null;
          recap.hidden = true;
          this.atc.dataset.empty = '';
          label.textContent = this.emptyLabel;
          total.textContent = '';
          if (minNote) minNote.hidden = true;
          return;
        }
        const add = this.margin?.checked ? (Number(this.dataset.margin) || 5) * 2 : 0;
        const cw = w + add;
        const ch = h + add;
        // Même règle que le service sur mesure : dixième de m² supérieur, 1 m² au minimum.
        // Minimum de commande (3 m²) : en dessous, la surface facturée passe au minimum. Le service applique la même règle.
        const minM2 = Number(this.dataset.minM2) || 3;
        const raw = Math.ceil((cw * ch) / 1000 - 1e-9) / 10;
        const m2 = Math.max(minM2, raw);
        const laize = Number(this.dataset.laize) || 95;
        const les = Math.max(1, Math.ceil(cw / laize));
        const cents = Math.round(Number(this.dataset.unitCents) * m2);
        // Le kit d'étanchéité est inclus dans le prix : le nombre de kits ne sert qu'à la préparation (propriété cachée _Kits).
        const kits = Math.ceil(m2 / (Number(this.dataset.kitM2) || 4) - 1e-9);
        this.#dims = { w, h, cw, ch, m2, les, cents, kits, min: raw < minM2 };

        const fr = (n) => n.toLocaleString('fr-FR', { maximumFractionDigits: 1 });
        this.querySelector('[data-msetan-r="wall"]').textContent = `${w} × ${h} cm`;
        this.querySelector('[data-msetan-r="crop"]').textContent = add ? `${cw} × ${ch} cm (+${add / 2} cm de chaque côté)` : `${cw} × ${ch} cm, sans marge`;
        this.querySelector('[data-msetan-r="m2"]').textContent = `${fr(m2)} m²`;
        this.querySelector('[data-msetan-r="les"]').textContent = `${les} lé${les > 1 ? 's' : ''} de ${laize} cm`;
        recap.hidden = false;
        delete this.atc.dataset.empty;
        label.textContent = 'Ajouter au panier';
        total.textContent = this.#money(cents);
        if (minNote) minNote.hidden = !this.#dims.min;
      }

      #say(message, isError = false) {
        const s = this.querySelector('[data-msetan-status]');
        s.textContent = message;
        s.classList.toggle('is-error', isError);
      }

      /* ── Le panier ── */
      async #exactVariant(d) {
        const endpoint = this.dataset.endpoint;
        if (!endpoint) return null;
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch(new URL('/variant', endpoint), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ product_id: Number(this.dataset.productId), variant_id: Number(this.dataset.baseId), width_cm: d.cw, height_cm: d.ch, min_m2: Number(this.dataset.minM2) || 3 }),
            signal: controller.signal,
          });
          const data = await response.json().catch(() => null);
          if (!response.ok || !data?.ok || !data.variant_id) return null;
          // Le prix du service doit être celui affiché (minimum de 3 m² compris) ; sinon, secours au m² entamé.
          const cents = Math.round(Number(data.price) * 100);
          if (cents !== d.cents) return null;
          const id = Number(data.variant_id);
          if (!data.reused) await this.#waitVisible(id, cents);
          return id;
        } catch (error) {
          console.error('L’Étanche :', error);
          return null;
        } finally {
          clearTimeout(timer);
        }
      }

      /** Une variante neuve met quelques secondes à être visible en boutique, et son prix parfois plus : sans lui, elle part à 0 €. */
      async #waitVisible(id, cents = 0) {
        for (let i = 0; i < 12; i += 1) {
          await new Promise((r) => setTimeout(r, i === 0 ? 1800 : 900));
          try {
            const p = await (await fetch(`/products/${this.dataset.productHandle}.js?ms=${Date.now()}`, { headers: { Accept: 'application/json' } })).json();
            if (p?.variants?.some((v) => v.id === id && v.available && (!cents || v.price === cents))) return true;
          } catch { /* on réessaie */ }
        }
        return false;
      }

      async #cartAdd(items) {
        const drawer = document.querySelector('cart-drawer');
        let response;
        for (let tries = 0; tries < 5; tries += 1) {
          response = await fetch(window.Theme?.routes?.cart_add_url ?? '/cart/add', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items, sections: drawer?.dataset?.sectionId }),
          });
          if (response.status !== 422) break;
          await new Promise((r) => setTimeout(r, 900));
        }
        const payload = await response.json().catch(() => null);
        if (!response.ok || !payload) throw new Error(payload?.description || 'cart');
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: {}, data: { source: 'ms-etanche', sections: payload.sections } } }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        if (!drawer) window.location.href = window.Theme?.routes?.cart_url ?? '/cart';
      }

      async #add() {
        const d = this.#dims;
        if (this.#pending) return;
        if (!d) {
          // « Calculer mon prix » sans cotes : on amène au premier champ vide.
          const empty = [this.w, this.h].find((i) => !(Number(i?.value) > 0));
          empty?.focus();
          empty?.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          return;
        }
        if (!this.#decor) { this.#openPicker(); return; }
        this.#pending = true;
        this.atc.setAttribute('aria-busy', 'true');
        this.#say('Préparation de votre décor…');
        const fr = (n) => n.toLocaleString('fr-FR', { maximumFractionDigits: 1 });
        const props = {
          'Décor': this.#decor.t,
          '_Fichier source': this.#decor.h,
          // Vignette du panier : le décor choisi (lu par le tiroir et la page panier).
          '_Aperçu': this.#decor.s,
          Support: this.dataset.supportName || '',
          Largeur: `${d.w} cm`,
          Hauteur: `${d.h} cm`,
          'Mesure du mur': `${d.w} × ${d.h} cm`,
          'Cadrage retenu': `${d.cw} × ${d.ch} cm`,
          'Surface facturée': `${fr(d.m2)} m²`,
          'Lés': `${d.les} lés de ${Number(this.dataset.laize) || 95} cm`,
          // Pour l'atelier, invisible pour la cliente : 1 kit d'étanchéité par tranche de 4 m² facturés.
          _Kits: String(d.kits),
        };
        if (d.min) props['Surface facturée'] = `${fr(d.m2)} m² (minimum de commande)`;
        try {
          const exactId = await this.#exactVariant(d);
          if (exactId) {
            await this.#cartAdd([{ id: exactId, quantity: 1, properties: props }]);
          } else {
            // Secours, comme sur les fiches décors : le service ne répond pas, facturation au m² entamé.
            const units = Math.ceil(d.m2 - 1e-9);
            // Surface déjà entière (minimum de 3 m² par exemple) : rien n'est arrondi, le libellé reste celui du calcul.
            if (units !== d.m2) props['Surface facturée'] = `${units} m² (arrondi, calcul exact indisponible)`;
            await this.#cartAdd([{ id: Number(this.dataset.baseId), quantity: units, properties: props }]);
          }
          this.#say('');
        } catch (error) {
          this.#say(error?.message && error.message !== 'cart' ? error.message : 'Ajout au panier impossible. Réessayez, ou écrivez-nous.', true);
        } finally {
          this.#pending = false;
          this.atc.removeAttribute('aria-busy');
        }
      }

      async #addSample(button) {
        const id = Number(button.dataset.msetanSample);
        if (!id || button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');
        try {
          await this.#cartAdd([{ id, quantity: 1 }]);
        } catch {
          this.#say('Ajout au panier impossible. Réessayez.', true);
        } finally {
          button.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('ms-etanche', MsEtanche);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-grand-tirage"]) return;
  try {
    
  if (!customElements.get('ms-grand-tirage')) {
    // Le pop-up WhatsApp (ms-conciergerie) lit cette date : il ne s'invite pas juste après le tirage.
    const MSGT_QUIET_KEY = 'ms-popup-calme';
    const MSGT_QUIET_MS = 90000;

    class MsGrandTirage extends HTMLElement {
      #controller = null;
      #switching = false;

      connectedCallback() {
        this.#controller = new AbortController();
        const signal = this.#controller.signal;
        this.dialog = this.querySelector('[data-msgt-dialog]');
        this.form = this.querySelector('form');
        // Avec le script, l'adresse est vérifiée ici (message dans le pop-up, lu par les lecteurs d'écran) ; sans lui, le navigateur s'en charge.
        if (this.form) this.form.noValidate = true;

        // Page restée en cache après la fin (ou avant le début) : on rend la barre d'annonce habituelle.
        const now = Date.now();
        const start = Number(this.dataset.start) || 0;
        const end = Number(this.dataset.end) || 0;
        if (!this.hasAttribute('data-preview') && (now < start || (end && now >= end))) {
          document.querySelector('style[data-msgt-hide]')?.remove();
          this.hidden = true;
          return;
        }

        this.querySelector('[data-msgt-open]')?.addEventListener('click', () => this.open(), { signal });
        this.querySelector('[data-msgt-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog?.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); }, { signal });
        this.dialog?.addEventListener('close', () => this.#onClose(), { signal });
        this.form?.addEventListener('submit', (e) => this.#submit(e), { signal });

        // Retour d'un envoi : Shopify signale le résultat à tous les formulaires d'inscription de la page
        // (newsletter du pied de page comprise) ; on ne rouvre que si l'envoi est parti de ce pop-up.
        let sent = false;
        try { sent = sessionStorage.getItem('msgt-envoi') === '1'; sessionStorage.removeItem('msgt-envoi'); } catch (e) {}
        if (sent && this.querySelector('[data-msgt-reopen]')) {
          this.open();
          if (!this.querySelector('[data-msgt-pane="done"]')?.hidden) (window.dataLayer = window.dataLayer || []).push({ event: 'grand_tirage_inscription' });
        } else if (!sent) {
          // Inscription faite ailleurs sur la page : le pop-up reste sur son formulaire.
          this.querySelector('[data-msgt-pane="form"]')?.removeAttribute('hidden');
          this.querySelector('[data-msgt-pane="done"]')?.setAttribute('hidden', '');
        }
      }

      disconnectedCallback() {
        this.#controller?.abort();
      }

      open() {
        if (!this.dialog || this.dialog.open) return;
        // Jamais deux pop-ups : l'invitation WhatsApp se referme si elle est à l'écran.
        for (const other of document.querySelectorAll('dialog[open]')) if (other !== this.dialog) other.close();
        this.dialog.showModal();
        const done = !this.querySelector('[data-msgt-pane="done"]')?.hidden;
        // Au doigt, on ne place pas le curseur dans l'adresse : le clavier masquerait le pop-up dès l'ouverture.
        const touch = matchMedia('(pointer: coarse)').matches;
        if (done) this.querySelector('[data-msgt-pane="done"]')?.focus();
        else if (!touch) this.querySelector('[data-msgt-email]')?.focus();
        (window.dataLayer = window.dataLayer || []).push({ event: 'grand_tirage_ouverture' });
      }

      #onClose() {
        if (this.#switching) { this.#switching = false; return; }
        this.dialog.classList.remove('is-sending');
        try { sessionStorage.setItem(MSGT_QUIET_KEY, String(Date.now() + MSGT_QUIET_MS)); } catch (e) {}
        this.querySelector('[data-msgt-open]')?.focus();
      }

      #showError(text) {
        const box = this.querySelector('[data-msgt-error]');
        const input = this.querySelector('[data-msgt-email]');
        if (!box || !input) return;
        box.textContent = text;
        box.hidden = !text;
        if (text) {
          input.setAttribute('aria-invalid', 'true');
          input.setAttribute('aria-describedby', box.id);
          input.focus();
        } else {
          input.removeAttribute('aria-invalid');
        }
      }

      /**
       * On vérifie l'adresse, puis on laisse le formulaire partir normalement. Shopify exige son jeton
       * anti-robot (hCaptcha), qu'il ajoute lui-même à l'envoi classique : un envoi en arrière-plan reçoit
       * un 403 (vu le 30 oct. 2026). Après l'envoi, la page revient avec ?customer_posted=true et le
       * pop-up se rouvre sur « C'est noté » (data-msgt-reopen).
       */
      #submit(event) {
        const input = this.querySelector('[data-msgt-email]');
        if (!input?.checkValidity()) {
          event.preventDefault();
          this.#showError(input?.validity.valueMissing ? 'Indiquez votre adresse e-mail.' : 'Cette adresse e-mail ne semble pas valide.');
          return;
        }
        this.#showError('');
        this.querySelector('[data-msgt-submit]')?.setAttribute('aria-busy', 'true');
        try { sessionStorage.setItem('msgt-envoi', '1'); } catch (e) {}
        // La vérification anti-robot de Shopify peut afficher un puzzle (hCaptcha). Un <dialog> modal passe
        // au-dessus de tout et le rendrait impossible à résoudre : on garde le pop-up à l'écran, mais non modal.
        if (this.dialog?.open && this.dialog.matches(':modal')) {
          // L'événement « close » arrive en différé : c'est #onClose qui remet l'indicateur à zéro.
          this.#switching = true;
          this.dialog.close();
          this.dialog.show();
          this.dialog.classList.add('is-sending');
        }
      }
    }
    customElements.define('ms-grand-tirage', MsGrandTirage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-guide-index"] && !Shopify.designMode) return;
  try {
    
  /**
   * Verrou des articles réservés.
   *
   * Ce n'est PAS une sécurité : l'article reste public et indexable, et le code
   * est lisible dans la page. C'est un ressort commercial. Rien de confidentiel
   * ne doit passer par ici.
   */
  const MS_GUIDE_KEY = 'ms-guide-unlocked';

  class MsGuideGate {
    #dialog;
    #pending = null;

    constructor(root) {
      this.root = root;
      this.#dialog = root.querySelector('[data-ms-gate]');
      this.code = (root.dataset.gateCode || '').trim().toLowerCase();
      if (!this.#dialog || !this.code) return;

      if (this.#alreadyUnlocked()) this.#unlockAll();

      for (const button of root.querySelectorAll('[data-ms-unlock]')) {
        button.addEventListener('click', () => this.#ask(button.closest('[data-ms-locked]')));
      }

      root.querySelector('[data-ms-gate-submit]')?.addEventListener('click', () => this.#check());
      root.querySelector('[data-ms-gate-close]')?.addEventListener('click', () => this.#dialog.close());
      root.querySelector('[data-ms-gate-input]')?.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        this.#check();
      });
    }

    /** Le stockage peut lever (navigation privée, cookies bloqués) : on n'y compte jamais. */
    #alreadyUnlocked() {
      try { return localStorage.getItem(MS_GUIDE_KEY) === '1'; } catch { return false; }
    }

    #remember() {
      try { localStorage.setItem(MS_GUIDE_KEY, '1'); } catch { /* rien à mémoriser, tant pis */ }
    }

    #ask(card) {
      this.#pending = card;
      const input = this.root.querySelector('[data-ms-gate-input]');
      const error = this.root.querySelector('[data-ms-gate-error]');
      if (input) input.value = '';
      if (error) error.hidden = true;
      this.#dialog.showModal();
      input?.focus();
    }

    #check() {
      const input = this.root.querySelector('[data-ms-gate-input]');
      const error = this.root.querySelector('[data-ms-gate-error]');
      const given = (input?.value ?? '').trim().toLowerCase();

      if (given !== this.code) {
        if (error) error.hidden = false;
        input?.focus();
        input?.select();
        return;
      }

      this.#remember();
      this.#unlockAll();
      const target = this.#pending?.dataset.msUrl;
      this.#dialog.close();
      if (target) window.location.href = target;
    }

    #unlockAll() {
      for (const card of this.root.querySelectorAll('[data-ms-locked]')) {
        card.classList.remove('is-locked');
        card.querySelector('.ms-guide__lock-ic')?.remove();
        card.querySelector('.ms-guide__lock-tag')?.remove();

        // Le bouton redevient un lien : une fois ouvert, l'article se partage.
        const button = card.querySelector('[data-ms-unlock]');
        if (!button) continue;
        const link = document.createElement('a');
        link.href = card.dataset.msUrl || '#';
        link.textContent = button.textContent;
        button.replaceWith(link);
      }
    }
  }

  function msGuideBoot() {
    for (const root of document.querySelectorAll('.ms-guide')) {
      if (root.dataset.msReady) continue;
      root.dataset.msReady = '1';
      new MsGuideGate(root);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', msGuideBoot);
  else msGuideBoot();
  document.addEventListener('shopify:section:load', msGuideBoot);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * Hero défilant. Le défilement automatique n'est qu'un confort : tout marche
   * sans lui — les puces, le clavier, et la première diapositive reste lisible
   * si le script ne se charge jamais.
   */
  class MsHero extends HTMLElement {
    #controller = new AbortController();
    #timer = 0;
    #index = 0;
    #paused = false;

    connectedCallback() {
      this.slides = [...this.querySelectorAll('.ms-hero__slide')];
      this.dots = [...this.querySelectorAll('[data-ms-hero-dot]')];
      this.toggle = this.querySelector('[data-ms-hero-toggle]');
      this.delay = parseInt(this.dataset.autoplay ?? '', 10) || 0;

      this.#deferVideos();

      if (this.slides.length < 2) return;

      const { signal } = this.#controller;

      for (const dot of this.dots) {
        dot.addEventListener('click', () => {
          this.#go(parseInt(dot.dataset.msHeroDot, 10));
          // Un clic sur une puce est une prise en main : le défilement s'arrête,
          // sinon l'image change sous les doigts de qui vient de la choisir.
          this.#stop(true);
        }, { signal });
      }

      this.toggle?.addEventListener('click', () => this.#stop(!this.#paused), { signal });

      this.addEventListener('keydown', (e) => this.#onKey(e), { signal });
      this.addEventListener('pointerenter', () => this.#hold(true), { signal });
      this.addEventListener('pointerleave', () => this.#hold(false), { signal });
      this.addEventListener('focusin', () => this.#hold(true), { signal });
      this.addEventListener('focusout', () => this.#hold(false), { signal });

      // Onglet en arrière-plan : rien ne tourne dans le vide.
      document.addEventListener('visibilitychange', () => this.#hold(document.hidden), { signal });

      const still = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.delay && !still.matches) this.#start();
    }

    disconnectedCallback() {
      this.#controller.abort();
      clearInterval(this.#timer);
    }

    /**
     * Les vidéos attendent la fin du chargement de la page : l'affiche s'affiche
     * d'abord, seule et prioritaire. Qui a demandé moins d'animations garde l'affiche.
     */
    #deferVideos() {
      const videos = [...this.querySelectorAll('[data-ms-hero-video]')];
      if (!videos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const start = () => {
        for (const video of videos) {
          video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
          video.preload = 'auto';
          video.play().catch(() => {});
        }
      };
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once: true, signal: this.#controller.signal });
    }

    #onKey(event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      this.#go(this.#index + (event.key === 'ArrowRight' ? 1 : -1));
      this.#stop(true);
    }

    #go(next) {
      const count = this.slides.length;
      const target = ((next % count) + count) % count;
      if (target === this.#index) return;

      for (const [i, slide] of this.slides.entries()) {
        const on = i === target;
        slide.classList.toggle('is-active', on);
        slide.toggleAttribute('inert', !on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      }

      for (const [i, dot] of this.dots.entries()) {
        dot.classList.toggle('is-active', i === target);
        if (i === target) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      }

      this.#index = target;
    }

    #start() {
      clearInterval(this.#timer);
      this.#timer = setInterval(() => this.#go(this.#index + 1), this.delay);
    }

    /** Suspension temporaire (survol, focus, onglet caché) : l'état du bouton ne change pas. */
    #hold(on) {
      if (this.#paused || !this.delay) return;
      if (on) clearInterval(this.#timer);
      else this.#start();
    }

    /** Arrêt décidé par la visiteuse : il tient jusqu'à ce qu'elle le relance. */
    #stop(on) {
      this.#paused = on;
      clearInterval(this.#timer);
      if (!on && this.delay) this.#start();
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-pressed', String(on));
      const label = this.toggle.querySelector('[data-ms-hero-toggle-label]');
      if (label) label.textContent = on ? (this.dataset.playLabel || 'Relancer le défilement') : (this.dataset.pauseLabel || 'Arrêter le défilement');
    }
  }

  if (!customElements.get('ms-hero')) customElements.define('ms-hero', MsHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-histoire"] && !Shopify.designMode) return;
  try {
    
  /**
   * Sommaire de « Notre histoire » : marque le chapitre en cours de lecture,
   * grise ceux déjà lus, et fait apparaître les blocs à l'entrée dans l'écran.
   */
  class MsHistoire extends HTMLElement {
    #observers = [];

    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      this.links = [...this.querySelectorAll('[data-mshist-link]')];
      this.#watchChapters();
      this.#watchReveal();
    }

    disconnectedCallback() {
      for (const observer of this.#observers) observer.disconnect();
      this.#observers = [];
    }

    #watchChapters() {
      const chapters = [...this.querySelectorAll('[data-mshist-ch]')];
      // Bande fine au milieu de l'écran : un seul chapitre la traverse à la fois.
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) this.#setCurrent(Number(entry.target.dataset.mshistCh));
        }
      }, { rootMargin: '-45% 0px -50% 0px' });
      for (const chapter of chapters) observer.observe(chapter);
      this.#observers.push(observer);
    }

    /** @param {number} index */
    #setCurrent(index) {
      for (const link of this.links) {
        const n = Number(link.dataset.mshistLink);
        link.classList.toggle('is-past', n < index);
        if (n === index) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      }
    }

    #watchReveal() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const blocks = [...this.querySelectorAll('.mshist__reveal')];
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      }, { rootMargin: '0px 0px -8% 0px' });
      for (const block of blocks) {
        // Ce qui est déjà à l'écran au chargement ne joue pas d'animation.
        if (block.getBoundingClientRect().top < window.innerHeight) block.classList.add('is-in');
        else observer.observe(block);
      }
      this.classList.add('is-ready');
      this.#observers.push(observer);
    }
  }

  if (!customElements.get('ms-histoire')) customElements.define('ms-histoire', MsHistoire);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-maison"] && !Shopify.designMode) return;
  try {
    
  /* Révélation à l'entrée dans le viewport. Sans JS, ou si le mouvement est
     refusé, l'image est visible d'emblée : l'opacité nulle n'est posée que
     sous prefers-reduced-motion: no-preference. */
  (() => {
    if (!('IntersectionObserver' in window)) return;

    const boot = () => {
      for (const el of document.querySelectorAll('.ms-maison:not([data-ms-revealed])')) {
        el.dataset.msRevealed = '1';
        const observer = new IntersectionObserver((entries, obs) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
        observer.observe(el);
      }
    };

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-pose-tiroir"] && !Shopify.designMode) return;
  try {
    
  /**
   * Ouvre le détail de La Pose depuis n'importe quel bouton [data-ms-pose-more],
   * le referme (croix, fond, Échap) et rend le focus au bouton d'origine.
   */
  class MsPoseTiroir extends HTMLElement {
    #controller = new AbortController();
    #opener = null;

    connectedCallback() {
      this.dialog = this.querySelector('[data-ms-pose-drawer]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      const { signal } = this.#controller;

      document.addEventListener('click', (event) => {
        const opener = event.target instanceof Element ? event.target.closest('[data-ms-pose-more]') : null;
        if (!opener) return;
        event.preventDefault();
        this.open(opener);
      }, { signal });

      this.querySelector('[data-mspd-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.removeProperty('overflow');
        this.#opener?.focus();
      }, { signal });
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    /** @param {HTMLElement} opener */
    open(opener) {
      this.#opener = opener;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.querySelector('[data-mspd-close]')?.focus();
    }
  }

  if (!customElements.get('ms-pose-tiroir')) customElements.define('ms-pose-tiroir', MsPoseTiroir);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-process"] && !Shopify.designMode) return;
  try {
    
  /**
   * Parcours en onglets verticaux.
   *
   * Amélioration progressive : le HTML livré affiche les quatre panneaux à la
   * suite. C'est ce composant qui en masque trois. Sans JavaScript, la section
   * reste donc entièrement lisible.
   *
   * Clavier : flèches haut/bas et gauche/droite pour changer d'étape, Début et
   * Fin pour les extrémités. Un seul onglet reste dans l'ordre de tabulation.
   */
  class MsStepper extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      if (this.tabs.length < 2) return;

      for (const [i, tab] of this.tabs.entries()) {
        tab.addEventListener('click', () => this.#select(i));
        tab.addEventListener('keydown', (e) => this.#onKey(e, i));
      }
      this.#select(0, false);
    }

    #select(index, animate = true) {
      for (const [i, tab] of this.tabs.entries()) {
        const on = i === index;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        const panel = this.panels[i];
        if (!panel) continue;
        panel.hidden = !on;
        panel.removeAttribute('data-entering');
        if (on && animate) {
          // Forcer un reflow pour que l'animation reparte à chaque changement.
          void panel.offsetWidth;
          panel.setAttribute('data-entering', '');
        }
      }
    }

    #onKey(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          next = index === last ? 0 : index + 1;
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          next = index === 0 ? last : index - 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = last;
          break;
        default:
          return;
      }
      event.preventDefault();
      this.#select(next);
      this.tabs[next].focus();
    }
  }

  if (!customElements.get('ms-stepper')) customElements.define('ms-stepper', MsStepper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-projections"] && !Shopify.designMode) return;
  try {
    
  /**
   * La liste des projections d'une cliente, lue avec le code ?p= de l'adresse.
   * Les images arrivent une à une, en base64, et s'affichent en fondu.
   */
  class MsProjections extends HTMLElement {
    #ab = new AbortController();

    connectedCallback() {
      this.status = this.querySelector('[data-msproj-status]');
      this.grid = this.querySelector('[data-msproj-grid]');
      this.empty = this.querySelector('[data-msproj-empty]');
      const code = new URLSearchParams(window.location.search).get('p') || '';
      if (!/^[a-z0-9]{20}$/.test(code) || !this.dataset.endpoint) {
        this.#showEmpty();
        return;
      }
      this.#load(code);
    }

    disconnectedCallback() { this.#ab.abort(); }

    get #base() { return this.dataset.endpoint.replace(/\/(generate)?\/?$/, ''); }

    async #load(code) {
      const { signal } = this.#ab;
      let items = [];
      try {
        const r = await fetch(`${this.#base}/proj/${code}`, { signal });
        if (!r.ok) throw new Error(String(r.status));
        items = (await r.json()).items || [];
      } catch (err) {
        if (err?.name === 'AbortError') return;
        this.#showEmpty();
        return;
      }
      if (!items.length) { this.#showEmpty(); return; }

      const tpl = items.length === 1 ? this.dataset.one : this.dataset.many;
      this.status.textContent = (tpl || '').replace('{n}', String(items.length));
      const imgs = [];
      for (const it of items) {
        const card = this.#card(it);
        this.grid.appendChild(card.li);
        imgs.push([it.n, card.img]);
      }
      this.grid.hidden = false;
      // Une image à la fois : la première projection s'affiche vite, même sur un téléphone.
      for (const [n, img] of imgs) {
        if (signal.aborted) return;
        await this.#image(code, n, img, signal);
      }
    }

    #card(it) {
      const li = document.createElement('li');
      li.className = 'msproj__card';
      const media = document.createElement('div');
      media.className = 'msproj__media';
      const img = document.createElement('img');
      img.className = 'msproj__img';
      img.alt = (this.dataset.alt || '').replace('{decor}', it.t || '');
      img.width = 1200;
      img.height = 900;
      media.appendChild(img);

      const body = document.createElement('div');
      body.className = 'msproj__body';
      const name = document.createElement('p');
      name.className = 'msproj__name';
      name.textContent = it.t || '';
      body.appendChild(name);
      const at = new Date(it.at);
      if (!Number.isNaN(at.getTime())) {
        const date = document.createElement('p');
        date.className = 'msproj__date';
        const time = document.createElement('time');
        time.dateTime = it.at;
        time.textContent = at.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
        date.append(`${this.dataset.datePrefix || ''} `, time);
        body.appendChild(date);
      }

      li.append(media, body);
      if (it.u && it.u.startsWith('/') && !it.u.startsWith('//')) {
        const a = document.createElement('a');
        a.className = 'ms-btn';
        a.href = it.u;
        a.textContent = this.dataset.cta || '';
        li.appendChild(a);
      }
      return { li, img };
    }

    async #image(code, n, img, signal) {
      try {
        const r = await fetch(`${this.#base}/proj/${code}/${n}`, { signal });
        if (!r.ok) return;
        const mime = r.headers.get('x-mime') || 'image/png';
        const data = await r.text();
        await new Promise((res) => {
          img.onload = res;
          img.onerror = res;
          img.src = `data:${mime};base64,${data}`;
        });
        img.classList.add('is-on');
      } catch { /* image indisponible : la carte reste avec son décor */ }
    }

    #showEmpty() {
      this.status.textContent = '';
      this.grid.hidden = true;
      this.empty.hidden = false;
    }
  }

  if (!customElements.get('ms-projections')) customElements.define('ms-projections', MsProjections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = (root) => {
      if (root.dataset.msqBound) return;
      root.dataset.msqBound = '1';

      const modal = document.getElementById(root.dataset.modal);
      if (!modal) return;

      const answers = {};
      let current = 1;
      let reco = null;
      let opener = null;

      const bar = modal.querySelector('[data-msq-bar]');
      const stepLabel = modal.querySelector('[data-msq-current]');
      const steps = modal.querySelectorAll('[data-msq-step]');

      const show = (step) => {
        for (const panel of steps) panel.hidden = String(panel.dataset.msqStep) !== String(step);
        const index = parseInt(step, 10);
        if (Number.isFinite(index)) {
          current = index;
          if (stepLabel) stepLabel.textContent = index;
          if (bar) bar.style.transform = `scaleX(${(index - 1) / 4})`;
        } else {
          // Résultat, y compris après un raccourci (douche, locataire) : le parcours est complet.
          if (stepLabel) stepLabel.textContent = 4;
          if (bar) bar.style.transform = 'scaleX(1)';
        }
        modal.querySelector('.msq__body')?.scrollTo({ top: 0 });
      };

      /**
       * Le décor recommandé. Chaque bloc « Résultat » déclare les pièces, les
       * styles et les lumières qu'il sert ; on retient celui qui coche le plus.
       * La pièce et le style pèsent trois fois la lumière.
       */
      const matiere = root.dataset.logic === 'matiere';
      const cardFor = (key) => modal.querySelector(`[data-msq-result="${key}"]`);

      /**
       * Mode « matière » : mêmes règles que le quiz des fiches décors (snippets/ms-quiz-matiere),
       * la première qui s'applique l'emporte. 1 pièce, 2 statut, 3 contrainte, 4 budget.
       */
      const decideMatiere = () => {
        const [piece, statut, contrainte, budget] = [answers[1], answers[2], answers[3], answers[4]];
        let key = 'mat';
        if (piece === 'douche' && cardFor('etanche')) key = 'etanche';
        else if (statut === 'locataire') key = 'amovible';
        else if (piece === 'salle-de-bain' || piece === 'cuisine') key = 'vinyle';
        else if (contrainte === 'lavage-frequent') key = 'vinyle';
        else if (contrainte === 'enfants-animaux') key = 'mat';
        else if (budget === 'accessible') key = 'lisse';
        else if (budget === 'haut-de-gamme') key = 'vinyle';
        return cardFor(key) || cardFor('mat');
      };

      /* ── Suivi anonyme du mode matière : même format que le quiz des fiches (POST /quiz). ── */
      // Même fonction que snippets/ms-quiz-matiere : numéro de visiteur gardé par le navigateur, source d'arrivée, test.
      window.msQuizWho = window.msQuizWho || (() => {
        const rnd = () => { const b = new Uint8Array(10); crypto.getRandomValues(b); return [...b].map((x) => x.toString(36).padStart(2, '0')).join('').slice(0, 16); };
        let visitor = '';
        try {
          visitor = localStorage.getItem('ms-visiteur') || '';
          if (!/^[a-z0-9]{10,24}$/.test(visitor)) { visitor = rnd(); localStorage.setItem('ms-visiteur', visitor); }
        } catch (e) {}
        let src = '';
        try { src = sessionStorage.getItem('ms-source') || ''; } catch (e) {}
        if (!src) {
          const q = new URLSearchParams(location.search);
          let ref = '';
          try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
          const own = location.hostname.replace(/^www\./, '');
          if (q.get('gclid') || q.get('gbraid') || q.get('wbraid')) src = 'google-ads';
          else if (q.get('fbclid') && /cpc|paid|ads/i.test(q.get('utm_medium') || '')) src = 'meta-ads';
          else if (q.get('utm_source')) src = q.get('utm_source');
          else if (ref && !ref.endsWith(own) && !ref.endsWith('myshopify.com')) src = ref;
          else src = ref ? 'interne' : 'direct';
          try { sessionStorage.setItem('ms-source', src); } catch (e) {}
        }
        const sh = window.Shopify || {};
        return { visitor, src, test: !!(sh.designMode || (sh.theme && sh.theme.role && sh.theme.role !== 'main')) };
      });
      let session = null;
      let sent = '';
      let done = false;
      const STEP = { 1: 'piece', 2: 'statut', 3: 'contraintes', 4: 'budget' };
      const begin = () => {
        if (session) return;
        const bytes = new Uint8Array(10);
        crypto.getRandomValues(bytes);
        session = {
          id: [...bytes].map((b) => b.toString(36).padStart(2, '0')).join('').slice(0, 16),
          t: Date.now(),
          decor: '',
          device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
          chosen: false,
          etanche: false,
          ...window.msQuizWho(),
        };
        sent = '';
        done = false;
      };
      const track = () => {
        if (!matiere || !session || !answers[1] || !root.dataset.track) return;
        const body = JSON.stringify({
          ...session,
          step: done ? 'resultat' : STEP[current] || 'piece',
          result: done ? reco || '' : '',
          piece: answers[1] || '',
          statut: answers[2] || '',
          contraintes: answers[3] ? [answers[3]] : [],
          budget: answers[4] || '',
        });
        if (body === sent) return;
        sent = body;
        try {
          const url = new URL('/quiz', root.dataset.track).toString();
          if (!navigator.sendBeacon?.(url, new Blob([body], { type: 'text/plain' }))) fetch(url, { method: 'POST', body, keepalive: true, mode: 'no-cors' }).catch(() => {});
        } catch (e) {}
      };
      const noteCart = (card) => {
        if (!session || !card) return;
        const label = (q) => modal.querySelector(`[data-msq-answer="${answers[q]}"][data-msq-q="${q}"] .msq__answer-label`)?.textContent.trim();
        const name = card.querySelector('.msq__card-name')?.textContent.trim() || reco;
        const parts = [`${name} recommandé${session.chosen ? ' (choisi)' : ''}`, label(1), label(2), label(3), answers[4] ? `Budget : ${label(4)}` : '', 'Quiz de la page d’accueil'];
        fetch(`${window.Theme?.routes?.cart_url ?? '/cart'}/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Quiz matière': parts.filter(Boolean).join(' · '), _quiz_id: session.id } }),
        }).catch(() => {});
      };
      window.addEventListener('pagehide', track);
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') track(); });

      const decide = () => {
        if (matiere) return decideMatiere();
        const cards = [...modal.querySelectorAll('[data-msq-result]')];
        let best = null;
        let bestScore = -1;

        for (const card of cards) {
          const has = (attr, value) =>
            (card.dataset[attr] || '')
              .split(',')
              .map((s) => s.trim())
              .filter(Boolean)
              .includes(value);

          let score = 0;
          if (has('pieces', answers[1])) score += 3;
          if (has('styles', answers[2])) score += 3;
          if (has('lumieres', answers[3])) score += 1;

          if (score > bestScore) {
            bestScore = score;
            best = card;
          }
        }
        return best;
      };

      const finish = () => {
        const card = decide();
        reco = card ? card.dataset.msqResult : '';

        for (const c of modal.querySelectorAll('[data-msq-result]')) c.hidden = c !== card;

        const why = modal.querySelector('[data-msq-why]');
        if (why) {
          // Mode matière : le budget compte dans la recommandation, il figure donc dans la phrase.
          const bits = (matiere ? [1, 2, 3, 4] : [1, 2, 3])
            .map((n) => modal.querySelector(`[data-msq-answer="${answers[n]}"][data-msq-q="${n}"] .msq__answer-label`))
            .filter(Boolean)
            .map((el) => el.textContent.trim().toLowerCase());
          why.textContent = bits.length ? `${root.dataset.whyPrefix || 'Parce que vous avez répondu'} : ${bits.join(', ')}.` : '';
          why.hidden = !why.textContent;
        }

        // dataset met en camelCase : data-obj-rendu-title devient objRenduTitle.
        const box = modal.querySelector('[data-msq-objection]');
        const key = answers[4] || '';
        const camel = key.charAt(0).toUpperCase() + key.slice(1);
        const title = root.dataset[`obj${camel}Title`];
        const text = root.dataset[`obj${camel}Text`];
        if (box) {
          modal.querySelector('[data-msq-objection-title]').textContent = title || '';
          modal.querySelector('[data-msq-objection-text]').textContent = text || '';
          box.hidden = !title && !text;
        }

        const trail = [1, 2, 3, 4].map((n) => `Q${n} : ${answers[n] || ''}`).join(' | ');
        for (const input of modal.querySelectorAll('[data-msq-answers]')) input.value = trail;
        for (const input of modal.querySelectorAll('[data-msq-reco]')) input.value = reco || '';

        if (matiere) {
          // La matière recommandée sera pré-cochée sur les fiches décors (même clé que le quiz des fiches).
          try { if (reco && reco !== 'etanche') localStorage.setItem('ms-quiz-matiere', reco); } catch (e) {}
          (window.dataLayer = window.dataLayer || []).push({ event: 'quiz_matiere', resultat: reco, piece: answers[1] || '', statut: answers[2] || '', contraintes: answers[3] || '', budget: answers[4] || '', page: 'accueil' });
          done = true;
          track();
          noteCart(card);
        }

        show('result');
      };

      const open = (from) => {
        opener = from || null;
        modal.hidden = false;
        if (window.msScrollLock) window.msScrollLock(true);
        else document.documentElement.style.overflow = 'hidden';
        modal.querySelector('[data-msq-step="1"] .msq__answer')?.focus();
      };

      const close = () => {
        modal.hidden = true;
        if (window.msScrollLock) window.msScrollLock(false);
        else document.documentElement.style.overflow = '';
        // Le focus revient là d'où on est parti : sinon il tombe en haut de page.
        opener?.focus?.();
      };

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-msq-open]');
        if (trigger) return open(trigger);
        if (event.target.closest('[data-msq-close]') && modal.contains(event.target)) return close();

        const answer = event.target.closest('[data-msq-answer]');
        if (answer && modal.contains(answer)) {
          const q = parseInt(answer.dataset.msqQ, 10);
          if (matiere && q === 1) {
            // Nouveau quiz : les réponses d'un passage précédent ne comptent plus.
            if (done) session = null;
            for (const k of [2, 3, 4]) delete answers[k];
            begin();
          }
          answers[q] = answer.dataset.msqAnswer;
          // Mode matière : la douche et la location décident seules, inutile de poser la suite.
          const enough = matiere && ((q === 1 && answers[1] === 'douche' && cardFor('etanche')) || (q === 2 && answers[2] === 'locataire'));
          if (q >= 4 || enough) finish();
          else show(q + 1);
          return;
        }

        const cta = event.target.closest('[data-msq-cta]');
        if (cta && modal.contains(cta) && matiere && session) {
          session[reco === 'etanche' ? 'etanche' : 'chosen'] = true;
          track();
          noteCart(cta.closest('[data-msq-result]'));
        }

        if (event.target.closest('[data-msq-back]') && modal.contains(event.target)) {
          show(Math.max(current - 1, 1));
          return;
        }

        const goto = event.target.closest('[data-msq-goto]');
        if (goto && modal.contains(goto)) show(goto.dataset.msqGoto);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) close();
      });

      if (window.location.hash === '#quiz') open();
    };

    const start = () => {
      for (const el of document.querySelectorAll('[data-msq-config]')) boot(el);
    };

    start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-technique"] && !Shopify.designMode) return;
  try {
    
  /** Le tiroir « Comparer nos matières » : ouvert par [data-ms-compare] (bloc d'achat). */
  class MsTechDrawer {
    constructor(dialog) {
      this.dialog = dialog;
      this.triggers = [...document.querySelectorAll('[data-ms-compare]')];
      if (!this.triggers.length || typeof dialog.showModal !== 'function') return;
      for (const t of this.triggers) {
        t.hidden = false;
        t.addEventListener('click', () => this.open());
      }
      dialog.querySelector('[data-mstech-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { document.documentElement.style.overflow = this.prevOverflow ?? ''; });
      for (const b of dialog.querySelectorAll('[data-mstech-choose]')) {
        b.addEventListener('click', () => this.choose(b.dataset.mstechChoose));
      }
      // Fenêtre « Comparez nos matières » : des onglets, un décor, une fiche.
      this.tabs = [...dialog.querySelectorAll('[data-mstech-tab]')];
      this.media = dialog.querySelector('[data-mstech-media]');
      if (this.tabs.length) this.bindTabs();
      dialog.querySelector('[data-mstech-sample]')?.addEventListener('click', () => this.toSample());
    }

    bindTabs() {
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          const keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
          let next = null;
          if (e.key in keys) next = (i + keys[e.key] + this.tabs.length) % this.tabs.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = this.tabs.length - 1;
          if (next === null) return;
          e.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        });
      });
    }

    /** Un onglet choisi : sa fiche s'affiche, le décor prend le grain de ce support. */
    select(index) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
        if (on) {
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          if (this.media) {
            this.media.className = this.media.className.replace(/\bmstech-tex--\S+/g, '').trim() + ` mstech-tex--${tab.dataset.mstechTex || 'mat'}`;
            const cap = this.media.querySelector('[data-mstech-cap]');
            if (cap) cap.textContent = tab.dataset.mstechName || '';
          }
        }
      });
    }

    /** « Le recevoir » : la fenêtre se ferme sur l'échantillon de matière, ouvert. */
    toSample() {
      this.dialog.close();
      const ech = document.querySelector('[data-ms-essai]');
      if (!ech) return;
      if (ech.tagName === 'DETAILS') ech.open = true;
      ech.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      ech.querySelector('summary')?.focus({ preventScroll: true });
    }

    /** Le support coché dans le bloc d'achat dont le nom contient le fragment. */
    radioFor(match) {
      const m = String(match || '').toLowerCase().trim();
      if (!m) return null;
      return [...document.querySelectorAll('[data-ms-support]')].find((r) => (r.dataset.name || '').toLowerCase().includes(m)) || null;
    }

    open() {
      const checked = document.querySelector('[data-ms-support]:checked');
      for (const b of this.dialog.querySelectorAll('[data-mstech-choose]')) {
        const current = checked && this.radioFor(b.dataset.mstechChoose) === checked;
        b.classList.toggle('is-current', Boolean(current));
        b.setAttribute('aria-pressed', current ? 'true' : 'false');
        b.textContent = current ? b.dataset.current : b.dataset.label;
      }
      // La fenêtre s'ouvre sur le support déjà coché dans le bloc d'achat.
      if (this.tabs?.length) {
        const at = this.tabs.findIndex((t) => checked && this.radioFor(t.dataset.mstechMatch) === checked);
        this.select(at >= 0 ? at : 0);
      }
      this.prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('ms-cfg-open');
      // Ouverte depuis le configurateur, celui-ci reste ouvert dessous : on garde alors la classe.
      this.dialog.addEventListener('close', () => {
        if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('ms-cfg-open');
      }, { once: true });
      this.dialog.showModal();
      this.dialog.querySelector('[data-mstech-close]')?.focus({ preventScroll: true });
    }

    choose(match) {
      const radio = this.radioFor(match);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.dialog.close();
      radio?.focus({ preventScroll: true });
    }
  }

  for (const d of document.querySelectorAll('[data-mstech-drawer]')) new MsTechDrawer(d);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-trouver-decor"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = (card) => {
      if (card.dataset.mstdBound) return;
      card.dataset.mstdBound = '1';
      const ask = card.querySelector('[data-mstd-ask]');
      if (!ask) return;

      ask.addEventListener('click', (event) => {
        const dialog = document.querySelector('[data-mscg-dialog]');
        if (!dialog || typeof dialog.showModal !== 'function') return; // sans conciergerie : le lien suit l'ancre
        event.preventDefault();
        // La conciergerie écoute l'ancre #conciergerie : si elle est déjà dans
        // l'adresse (fenêtre refermée), on rejoue l'événement.
        if (window.location.hash === '#conciergerie') window.dispatchEvent(new Event('hashchange'));
        else window.location.hash = '#conciergerie';

        const topic = card.dataset.topic;
        if (!topic) return;
        const radio = dialog.querySelector(`[data-mscg-topic][value="${CSS.escape(topic)}"]`);
        if (!radio) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };
    const start = () => { for (const el of document.querySelectorAll('[data-mstd]')) boot(el); };
    start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-visualiseur"] && !Shopify.designMode) return;
  try {
    
  /**
   * « Voir dans ma pièce » : la photo part vers le Worker, qui pose le décor
   * et renvoie l'image. Quelques secondes sous le logo, puis l'image   * du résultat, en plein cadre et en fondu.
   */
  class MsVisualiseur extends HTMLElement {
    #ab = null;
    #photoBlob = null;
    #decorBlob = null;
    #decorUrl = '';
    #pendingOpen = false;
    #resultSrc = '';
    #timers = [];
    #reduced = false;
    #sample = null;
    #gen = '';

    connectedCallback() {
      this.dialog = this.querySelector('[data-msvz-dialog]');
      this.trigger = this.querySelector('[data-msvz-open]');
      if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;

      this.#reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scene = this.querySelector('[data-msvz-scene]');
      this.afterEl = this.querySelector('[data-msvz-after]');
      this.result = this.querySelector('[data-msvz-result]');
      this.errorEl = this.querySelector('[data-msvz-error]');
      this.remainingEl = this.querySelector('[data-msvz-remaining]');
      this.decorEl = this.querySelector('[data-msvz-decor]');
      this.userMode = this.dataset.decorSource === 'user';

      try { this.#sample = JSON.parse(this.querySelector('script[data-msvz-sample]')?.textContent ?? 'null'); } catch { this.#sample = null; }

      this.#placeTrigger();
      this.#bind();
      this.#renderRemaining(this.#storedRemaining());
    }

    disconnectedCallback() { this.#clearTimers(); this.#ab?.abort(); }

    /* ── Le bouton va sous l'image de la galerie, comme sur la maquette. ── */
    #placeTrigger() {
      const slot = document.querySelector('[data-ms-visu-slot]');
      this.slot = slot;
      if (slot) slot.appendChild(this.trigger);
      // Page Personnalisation : le bouton attend l'image déposée dans le configurateur.
      if (this.userMode) {
        document.addEventListener('ms-perso:image', (e) => this.setDecor(e.detail?.file));
        // Le bouton est là dès l'arrivée : on comprend tout de suite que c'est possible.
        if (slot) slot.hidden = false;
        this.trigger.hidden = false;
        if (window.msPersoImage) this.setDecor(window.msPersoImage);
        return;
      }
      if (slot) slot.hidden = false;
      this.trigger.hidden = false;
    }

    /** L'image de la cliente devient le motif à poser (page Personnalisation). */
    setDecor(file) {
      const ok = Boolean(file && file.type && file.type.startsWith('image/'));
      this.#decorBlob = ok ? file : null;
      if (this.#decorUrl) URL.revokeObjectURL(this.#decorUrl);
      this.#decorUrl = ok ? URL.createObjectURL(file) : '';
      if (this.decorEl) {
        if (ok) this.decorEl.src = this.#decorUrl;
        else this.decorEl.removeAttribute('src');
      }
      if (!ok && this.dialog.open) this.close();
      // La cliente avait cliqué avant d'avoir une image : on ouvre maintenant.
      if (ok && this.#pendingOpen) {
        this.#pendingOpen = false;
        this.open();
      }
    }

    #bind() {
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('[data-msvz-close]')?.addEventListener('click', () => this.close());
      this.dialog.addEventListener('close', () => this.#onClose());
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });

      this.querySelector('[data-msvz-file]')?.addEventListener('change', (e) => {
        const file = e.target.files?.[0];
        e.target.value = '';
        if (file) this.#start(file);
      });
      this.querySelector('[data-msvz-example]')?.addEventListener('click', () => this.#useExample());
      this.querySelector('[data-msvz-cancel]')?.addEventListener('click', () => this.#reset());
      this.querySelector('[data-msvz-retry]')?.addEventListener('click', () => this.#reset());
      // Le bouton, pas le bloc de données JSON qui porte le même repère et le précède dans la page.
      this.querySelector('button[data-msvz-sample]')?.addEventListener('click', (e) => this.#addSample(e.currentTarget));
      this.querySelector('[data-msvz-cart]')?.addEventListener('click', () => this.#toCart());
      this.querySelector('[data-msvz-download]')?.addEventListener('click', (e) => {
        if (!this.#resultSrc) { e.preventDefault(); return; }
        this.#track('visualizer_download');
      });
    }

    open() {
      if (this.dialog.open) return;
      // Page Personnalisation sans image : d'abord choisir son image.
      if (this.userMode && !this.#decorBlob) {
        this.#pendingOpen = true;
        const input = document.querySelector('[data-perso-file]');
        if (input) { input.click(); return; }
        this.#pendingOpen = false;
      }
      this.dialog.showModal();
      if (window.msScrollLock) window.msScrollLock(true);
      this.#track('visualizer_open');
      this.#focusPanel();
    }

    close() { if (this.dialog.open) this.dialog.close(); }

    #onClose() {
      if (window.msScrollLock) window.msScrollLock(false);
      this.#reset();
    }

    #showPanel(name) {
      for (const p of this.querySelectorAll('[data-msvz-panel]')) p.hidden = p.dataset.msvzPanel !== name;
      this.scene.dataset.msvzMode = name;
      if (this.dialog.open) this.#focusPanel();
    }

    #focusPanel() {
      if (navigator.maxTouchPoints > 0) return;
      const panel = this.querySelector('[data-msvz-panel]:not([hidden])');
      panel?.querySelector('[data-msvz-focus]')?.focus({ preventScroll: true });
    }

    /* ── Départ : la photo choisie, puis la demande au serveur. ── */
    async #start(file) {
      if (!file.type || !file.type.startsWith('image/')) { this.#showError(this.dataset.errPhoto); return; }
      this.#hideError();
      this.#photoBlob = file;
      this.#track('visualizer_upload');
      await this.#generate();
    }

    async #useExample() {
      const url = this.dataset.exampleUrl;
      if (!url) return;
      const label = this.querySelector('[data-msvz-file-label]');
      label?.classList.add('is-busy');
      try {
        const r = await fetch(url);
        if (!r.ok) throw new Error('example');
        const blob = await r.blob();
        await this.#start(new File([blob], 'exemple.jpg', { type: blob.type || 'image/jpeg' }));
      } catch {
        this.#showError(this.dataset.errFailed);
      } finally {
        label?.classList.remove('is-busy');
      }
    }

    async #generate() {
      this.#ab?.abort();
      this.#ab = new AbortController();
      const { signal } = this.#ab;
      this.result.classList.remove('is-on');
      this.result.hidden = true;
      this.#showPanel('work');
      const started = performance.now();

      try {
        if (!this.#decorBlob) {
          if (this.userMode || !this.dataset.decorUrl) throw Object.assign(new Error('decor'), { code: 'decor' });
          const r = await fetch(this.dataset.decorUrl, { signal });
          if (!r.ok) throw Object.assign(new Error('decor'), { code: 'decor' });
          this.#decorBlob = await r.blob();
        }
        const out = await this.#visualiser(this.dataset.endpoint, this.#photoBlob, this.#decorBlob, signal);
        if (signal.aborted) return;
        this.#resultSrc = out.src;
        this.#gen = out.gen || '';
        if (out.remaining !== null && out.remaining !== undefined && out.remaining !== '') {
          this.#storeRemaining(out.remaining);
          this.#renderRemaining(out.remaining);
        }
        this.#track('visualizer_result');
        // Le logo reste au moins un instant : un écran qui clignote inquiète.
        const elapsed = performance.now() - started;
        if (elapsed < 1200) await this.#wait(1200 - elapsed);
        if (signal.aborted) return;
        if (this.#gateOn()) await this.#gate();
        else await this.#showResult();
      } catch (err) {
        if (signal.aborted || err?.name === 'AbortError') return;
        this.#showPanel('upload');
        const code = err?.code || '';
        if (code === 'decor') {
          this.#showError(this.dataset.errDecor || this.dataset.errFailed);
        } else if (code === 'limit_ip' || code === 'limit_global') {
          this.#storeRemaining(0);
          this.#renderRemaining(0);
          this.#showError(this.dataset.errLimit);
        } else if (code === 'too_large' || code === 'bad_request' || code === 'photo') {
          this.#showError(this.dataset.errPhoto);
        } else {
          this.#showError(this.dataset.errFailed);
        }
      }
    }

    /** Redimensionne en JPEG (1536 px, qualité 0,85), orientation EXIF respectée. */
    async #toJpegB64(blob, max = 1536, q = 0.85) {
      let bmp;
      try { bmp = await createImageBitmap(blob, { imageOrientation: 'from-image' }); }
      catch { throw Object.assign(new Error('photo'), { code: 'photo' }); }
      const s = Math.min(1, max / Math.max(bmp.width, bmp.height));
      const c = document.createElement('canvas');
      c.width = Math.round(bmp.width * s);
      c.height = Math.round(bmp.height * s);
      c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
      bmp.close?.();
      return c.toDataURL('image/jpeg', q).split(',')[1];
    }

    async #visualiser(endpoint, photoBlob, decorBlob, signal) {
      const [photo, decor] = await Promise.all([this.#toJpegB64(photoBlob), this.#toJpegB64(decorBlob)]);
      const r = await fetch(endpoint, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ photo, decor }),
        signal,
      });
      if (!r.ok) {
        const e = await r.json().catch(() => ({}));
        throw Object.assign(new Error(e.error || 'error'), { code: e.error, status: r.status });
      }
      const d = await r.json();
      const part = (d.candidates?.[0]?.content?.parts || []).find((p) => p.inlineData || p.inline_data);
      const img = part && (part.inlineData || part.inline_data);
      if (!img) throw Object.assign(new Error('no_image'), { code: 'no_image' });
      return { src: `data:${img.mimeType || img.mime_type};base64,${img.data}`, remaining: r.headers.get('x-remaining'), gen: r.headers.get('x-gen') };
    }

    /* ── L'e-mail avant le résultat ── */
    #gateOn() {
      return this.dataset.gate === 'true' && Boolean(this.#gen) && Boolean(this.querySelector('[data-msvz-gate]'));
    }

    /** Déjà donné sur cet appareil : la projection rejoint sa page, sans redemander. */
    async #gate() {
      const me = this.#me();
      const form = this.querySelector('[data-msvz-gate]');
      const required = Boolean(form?.querySelector('[data-msvz-consent][required]'));
      // Une adresse donnée sans accord, quand la case est obligatoire : on redemande l'accord.
      if (me && (me.k || !required)) {
        this.#claim(me.e, false).catch(() => {});
        this.#showMine(me.c);
        await this.#showResult();
        return;
      }
      await this.#showResult(true);
      const field = form?.querySelector('[data-msvz-email]');
      if (me && field && !field.value) field.value = me.e;
      if (form && !form.dataset.bound) {
        form.dataset.bound = '1';
        form.addEventListener('submit', (e) => { e.preventDefault(); this.#submitGate(form); });
        // L'erreur disparaît dès qu'on corrige l'adresse.
        form.querySelector('[data-msvz-email]')?.addEventListener('input', (e) => {
          const err = form.querySelector('[data-msvz-gate-error]');
          if (err && !err.hidden) { err.hidden = true; err.textContent = ''; e.target.removeAttribute('aria-invalid'); }
        });
        form.querySelector('[data-msvz-consent]')?.addEventListener('change', (e) => {
          const err = form.querySelector('[data-msvz-gate-error]');
          if (e.target.checked && err && !err.hidden) { err.hidden = true; err.textContent = ''; e.target.removeAttribute('aria-invalid'); }
        });
      }
    }

    async #submitGate(form) {
      const input = form.querySelector('[data-msvz-email]');
      const err = form.querySelector('[data-msvz-gate-error]');
      const email = (input?.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        input?.setAttribute('aria-invalid', 'true');
        if (err) { err.textContent = this.dataset.errEmail || ''; err.hidden = false; }
        input?.focus();
        return;
      }
      input?.removeAttribute('aria-invalid');
      if (err) { err.hidden = true; err.textContent = ''; }
      const box = form.querySelector('[data-msvz-consent]');
      const consent = Boolean(box?.checked);
      if (box && box.required && !consent) {
        box.setAttribute('aria-invalid', 'true');
        if (err) { err.textContent = this.dataset.errConsent || ''; err.hidden = false; }
        box.focus();
        return;
      }
      box?.removeAttribute('aria-invalid');
      // L'image se dévoile tout de suite ; le serveur range la projection pendant
      // ce temps (1 à 2 s), puis le lien vers la page de projections apparaît.
      const pending = this.#claim(email, consent).catch(() => '');
      this.#track('visualizer_email', { consent });
      this.#unlock();
      const code = await pending;
      if (!code) return;
      try { localStorage.setItem('msvz:me', JSON.stringify({ e: email.toLowerCase(), c: code, k: consent })); } catch { /* stockage indisponible */ }
      this.#showMine(code);
    }

    /** @returns {Promise<string>} le code de la page de projections */
    async #claim(email, consent) {
      const url = this.dataset.endpoint.replace(/\/generate\/?$/, '') + '/claim';
      const r = await fetch(url, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ gen: this.#gen, email, consent, title: this.dataset.decorName || '', url: window.location.pathname }),
      });
      const d = await r.json().catch(() => ({}));
      return r.ok && d.code ? d.code : '';
    }

    #me() {
      try {
        const me = JSON.parse(localStorage.getItem('msvz:me') || 'null');
        return me && me.e && /^[a-z0-9]{20}$/.test(me.c || '') ? me : null;
      } catch { return null; }
    }

    #showMine(code) {
      const a = this.querySelector('[data-msvz-mine]');
      if (!a) return;
      const page = new URL(this.dataset.projectionPage || '/pages/ma-projection', window.location.origin);
      page.searchParams.set('p', code);
      a.href = page.pathname + page.search;
      a.hidden = false;
    }

    #unlock() {
      this.result.classList.remove('is-locked');
      this.#showPanel('result');
    }

    /* ── Le résultat, en fondu (flouté tant que l'e-mail n'est pas donné). ── */
    async #showResult(locked = false) {
      const dl = this.querySelector('[data-msvz-download]');
      if (dl) { dl.href = this.#resultSrc; dl.download = this.dataset.downloadName || 'maison-soubise.jpg'; }
      await new Promise((res) => {
        this.afterEl.onload = () => res();
        this.afterEl.onerror = () => res();
        this.afterEl.src = this.#resultSrc;
        if (this.afterEl.complete) res();
      });
      this.result.hidden = false;
      this.result.classList.toggle('is-locked', locked);
      this.#showPanel(locked ? 'gate' : 'result');
      await this.#wait(this.#reduced ? 0 : 30);
      this.result.classList.add('is-on');
    }

    #reset() {
      this.#ab?.abort();
      this.#ab = null;
      this.#clearTimers();
      this.result.classList.remove('is-on');
      this.result.classList.remove('is-locked');
      this.result.hidden = true;
      this.#resultSrc = '';
      this.#gen = '';
      this.#hideError();
      this.#showPanel('upload');
    }

    /* ── L'Échantillon, sur le support choisi dans le bloc d'achat. ── */
    async #addSample(button) {
      if (!this.#sample) return;
      const picked = document.querySelector('[data-ms-support]:checked');
      const support = picked?.dataset.name || '';
      const entry = this.#sample[support] || Object.values(this.#sample).find((v) => v.available) || null;
      if (!entry) return;
      // Échantillon de matière : il ne porte pas ce décor, la ligne ne le nomme pas.
      const properties = {};
      // Le Nuancier contient les trois supports à poser à la colle : pas de « Support » sur sa ligne.
      if (support && !entry.nuancier) properties.Support = support;
      if (entry.format) properties.Format = entry.format;
      button.classList.add('is-busy');
      try {
        const drawer = document.querySelector('cart-drawer');
        const r = await fetch(window.Theme?.routes?.cart_add_url ?? '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: entry.id, quantity: 1, properties }], sections: drawer?.dataset?.sectionId }),
        });
        const payload = await r.json().catch(() => null);
        if (!r.ok || !payload) throw new Error(payload?.description || 'cart');
        this.#track('visualizer_add_to_cart', { item: 'sample' });
        this.close();
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: {}, data: { source: 'ms-visualiseur', sections: payload.sections } } }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      } catch {
        window.location.href = window.Theme?.routes?.cart_url ?? '/cart';
      } finally {
        button.classList.remove('is-busy');
      }
    }

    /* ── Commander le décor : le bloc d'achat sait déjà tout faire. ── */
    #toCart() {
      this.#track('visualizer_add_to_cart', { item: 'decor' });
      this.close();
      if (this.userMode) {
        const add = document.querySelector('[data-perso-add]');
        window.setTimeout(() => {
          add?.scrollIntoView({ block: 'center', behavior: this.#reduced ? 'auto' : 'smooth' });
          if (add && !add.disabled) add.focus({ preventScroll: true });
        }, 120);
        return;
      }
      const atc = document.querySelector('[data-ref="add-to-cart-button"]');
      const width = document.querySelector('[data-ms-w]');
      window.setTimeout(() => {
        if (atc && !atc.disabled && width && width.value) { atc.click(); return; }
        (width || atc)?.scrollIntoView({ block: 'center', behavior: this.#reduced ? 'auto' : 'smooth' });
        width?.focus({ preventScroll: true });
      }, 120);
    }

    /* ── Les essais du jour ── */
    #storedRemaining() {
      try {
        const raw = sessionStorage.getItem('msvz:remaining');
        if (raw === null) return null;
        const [day, n] = raw.split('|');
        return day === new Date().toISOString().slice(0, 10) ? Number(n) : null;
      } catch { return null; }
    }
    #storeRemaining(n) {
      try { sessionStorage.setItem('msvz:remaining', `${new Date().toISOString().slice(0, 10)}|${Number(n)}`); } catch { /* stockage indisponible */ }
    }
    #renderRemaining(n) {
      if (!this.remainingEl) return;
      const per = Number(this.dataset.tries || 3);
      const left = n === null || n === undefined || Number.isNaN(Number(n)) ? per : Math.max(0, Number(n));
      this.remainingEl.textContent = (this.dataset.remainingTemplate || '{n} essais restants · {d} essais par jour')
        .replace('{n}', String(left)).replace('{d}', String(per));
    }

    #showError(msg) { if (this.errorEl) { this.errorEl.textContent = msg || ''; this.errorEl.hidden = !msg; } }
    #hideError() { if (this.errorEl) { this.errorEl.hidden = true; this.errorEl.textContent = ''; } }
    #wait(ms) { return new Promise((res) => { this.#timers.push(window.setTimeout(res, ms)); }); }
    #clearTimers() { for (const id of this.#timers) window.clearTimeout(id); this.#timers = []; }

    #track(name, params = {}) {
      const payload = { decor: this.dataset.decorName, ...params };
      try {
        if (typeof window.gtag === 'function') window.gtag('event', name, payload);
        else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...payload });
      } catch { /* mesure indisponible */ }
    }
  }

  if (!customElements.get('ms-visualiseur')) customElements.define('ms-visualiseur', MsVisualiseur);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-whatsapp-ms"] && !Shopify.designMode) return;
  try {
    
  class MsWhatsappPopup extends HTMLElement {
    #timer = null;
    #key = 'ms-wa-popup-until';
    #startKey = 'ms-wa-popup-start';

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      for (const button of this.querySelectorAll('[data-mswp-close]')) {
        button.addEventListener('click', () => this.close());
      }
      this.querySelector('[data-mswp-go]')?.addEventListener('click', () => {
        this.#remember(24 * 30);
        this.#track('whatsapp_popup_click');
        this.dialog.close();
      });
      // Échap ferme (fenêtre native) ; un clic sur le fond ne ferme pas :
      // seule la croix ou le lien de refus referment la carte.
      this.dialog.addEventListener('cancel', () => this.#remember());

      if (window.Shopify?.designMode) {
        this.#bindEditor();
        return;
      }
      if (this.#snoozed()) return;
      this.#schedule();
    }

    disconnectedCallback() {
      clearTimeout(this.#timer);
    }

    /** Le compteur court sur tout le site : première page → N secondes, navigation comprise. */
    #schedule() {
      const seconds = Number(this.dataset.seconds) || 120;
      let start = Date.now();
      try {
        const stored = Number(sessionStorage.getItem(this.#startKey));
        if (stored) start = stored;
        else sessionStorage.setItem(this.#startKey, String(start));
      } catch {
        /* stockage indisponible : compteur de page */
      }
      const elapsed = (Date.now() - start) / 1000;
      // Jamais à l'arrivée sur une page : au moins 4 s de lecture.
      const delay = Math.max(seconds - elapsed, 4);
      this.#timer = setTimeout(() => this.open(), delay * 1000);
    }

    open() {
      if (this.dialog.open) return;
      // Une autre fenêtre est ouverte (visualiseur, panier) : on repasse plus tard.
      if (document.querySelector('dialog[open]:not(.mswp)') || document.body.classList.contains('overflow-hidden')) {
        this.#timer = setTimeout(() => this.open(), 30000);
        return;
      }
      this.dialog.showModal();
      // Le focus va sur la carte, pas sur la croix (premier bouton focalisable).
      this.dialog.focus({ preventScroll: true });
      this.#track('whatsapp_popup_open');
    }

    close() {
      this.#remember();
      this.dialog.close();
    }

    #snoozed() {
      try {
        const until = Number(localStorage.getItem(this.#key));
        return Boolean(until) && Date.now() < until;
      } catch {
        return false;
      }
    }

    #remember(hours = Number(this.dataset.snoozeHours) || 24) {
      try {
        localStorage.setItem(this.#key, String(Date.now() + hours * 3600 * 1000));
      } catch {
        /* rien */
      }
    }

    #track(name) {
      try {
        window.dataLayer?.push({ event: name });
        if (typeof window.gtag === 'function') window.gtag('event', name);
      } catch {
        /* rien */
      }
    }

    /** Dans l'éditeur : la section sélectionnée ouvre la carte, désélectionnée la ferme. */
    #bindEditor() {
      const id = this.dataset.sectionId;
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail?.sectionId === id && !this.dialog.open) this.dialog.showModal();
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail?.sectionId === id && this.dialog.open) this.dialog.close();
      });
    }
  }

  if (!customElements.get('ms-whatsapp-popup')) {
    customElements.define('ms-whatsapp-popup', MsWhatsappPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
